"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailAuthModule = void 0;
const inversify_1 = require("inversify");
const http_status_codes_1 = require("http-status-codes");
const RetailCustomer_1 = require("../../models/RetailCustomer");
const AuthModule_1 = require("../../../../../apis/spg/client/modules/AuthModule");
const errorTypes_1 = require("../../../../../apis/spg/helpers/errorTypes");
const constants_1 = require("./helpers/constants");
let RetailAuthModule = class RetailAuthModule extends AuthModule_1.AuthModule {
    constructor(_httpConnection, _webSocketConnection, _syncModule, GenericSessionCls, GenericLocationCls) {
        super(_httpConnection, _webSocketConnection, _syncModule, GenericSessionCls, GenericLocationCls);
        this._httpConnection = _httpConnection;
        this._webSocketConnection = _webSocketConnection;
        this._syncModule = _syncModule;
        this.GenericSessionCls = GenericSessionCls;
        this.GenericLocationCls = GenericLocationCls;
    }
    async setSession(newSession) {
        var _a, _b;
        if (((_a = newSession === null || newSession === void 0 ? void 0 : newSession.retailCustomer) === null || _a === void 0 ? void 0 : _a.active) === false ||
            ((_b = newSession === null || newSession === void 0 ? void 0 : newSession.retailCustomer) === null || _b === void 0 ? void 0 : _b.suspend) === true) {
            await this.logout();
        }
        else {
            super.setSession(newSession);
        }
    }
    async loginAsCustomer(email, password) {
        try {
            const response = await this._httpConnection.makeRequest({
                url: `auth/login-as-retail-customer`,
                method: "post",
                data: {
                    email,
                    password
                },
                handleOwnError: true
            });
            // if we receive the retail customer only, we can handle the 2-step phone verification
            if (!response.session && response.retailCustomer) {
                return RetailCustomer_1.RetailCustomer.unserialize(response.retailCustomer);
            }
            // if we get the retail customer, it means we can directly login the customer without asking them to verify their account
            const sessionModel = this.GenericSessionCls.unserialize(response.session);
            if (response.session.sessionId) {
                await this.setSession(sessionModel);
            }
            return sessionModel;
        }
        catch (e) {
            if (!e.response) {
                throw e;
            }
            if (e.response.status === http_status_codes_1.StatusCodes.BAD_REQUEST &&
                e.response.data.error === constants_1.TSignInFormMessage.IncorrectEmailOrPassword) {
                throw new errorTypes_1.InvalidCredentialsError(e);
            }
            throw e;
        }
    }
};
RetailAuthModule = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)("HttpConnection")),
    __param(1, (0, inversify_1.inject)("WebSocketConnection")),
    __param(2, (0, inversify_1.inject)("SyncModule")),
    __param(3, (0, inversify_1.inject)("interfaces.Newable<RetailSession>")),
    __param(4, (0, inversify_1.inject)("interfaces.Newable<RetailLocation>"))
], RetailAuthModule);
exports.RetailAuthModule = RetailAuthModule;
//# sourceMappingURL=RetailAuthModule.js.map